<div>
  <ng-container *transloco="let t; prefix: 'home'">
    @if (!isDesignRoute()) {
      <span style="font-family: cursive; font-size: large; text-align: center; padding-bottom: 20px"><em>{{ t('introduction') }}</em></span>
    }
    <mat-cards-grid [cards]="cards"></mat-cards-grid>
  </ng-container>
</div>
